
import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TreatmentProcessSection from './components/TreatmentProcessSection';
import WhyTransparentSection from './components/WhyTransparentSection';
import InstructionsSection from './components/InstructionsSection';
import CleaningGuideSection from './components/CleaningGuideSection';
import GallerySection from './components/GallerySection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import FloatingIcons from './components/FloatingIcons';
import StickyBottomBar from './components/StickyBottomBar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <HeroSection />
      <TreatmentProcessSection />
      <WhyTransparentSection />
      <InstructionsSection />
      <CleaningGuideSection />
      <GallerySection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <FloatingIcons />
      <StickyBottomBar />
    </div>
  );
}
